import React, { useState, useEffect } from 'react';
import { Form, FormText } from 'reactstrap';

import { jt } from 'ttag';

import FormField from './FormField';

import ValidateName from './ValidateName';
import ValidateEmail from './ValidateEmail';
import ValidateTel from './ValidateTel';

import Loading from 'aulatime/src/components/Loading';

const ContactForm = ({ metadata, toggleModal = () => { return null; } }) => {
  //
  const dataBag = {
    value: '',
    error: '',
    valid: {},
    initialValue: ''
  }
  const initialState = {
    firstName: dataBag,
    lastName: dataBag,
    email: dataBag,
    tel: {
      ...dataBag,
      ...{ initialValue: '+34 ' }
    }
  }

  const [state, setState] = useState(initialState);
  const [success, setSuccess] = useState(0);
  const [error, setError] = useState(0);
  const [loading, setLoading] = useState(false);
  const [counter, setCounter] = useState('');
  const [valid, setValid] = useState(false);

  //
  useEffect(
    () => {
      let {firstName, lastName, email, tel} = state;

      const invalid = (field) => {
        const { valid } = field;
        return JSON.stringify(valid) === JSON.stringify({ invalid: true }) ||
          JSON.stringify(valid) === JSON.stringify({});
      };

      const isInvalid = [firstName, lastName, email, tel].some(invalid);
      setValid(!isInvalid);

    }, [state]
  );

  const handleChange = (field, updatedState) => {
    setState({
      ...state,
      [field]: {
        ...state[field],
        ...updatedState
      }
    });
  }

  const handleSuccess = () =>{
    setSuccess(1);
    countdown(5);

    setTimeout(() => {

      setLoading(false);
      setState(initialState);
      setSuccess(0);
      toggleModal();

    }, 7000);
  }

  const handleError = () => {
    setError(1);
    countdown(5);

    setTimeout(() => {

      setLoading(false);
      setError(0);

    }, 7000);
  }

  const handleSubmit = e => {
    e.preventDefault();

    if (valid) {

      setLoading(true);

      fetch('/postmanp', {
        method: 'POST',
        body: JSON.stringify(
          {
            ...{
              email: state.email.value,
              firstName: state.firstName.value,
              lastName: state.lastName.value,
              tel: state.tel.value
            },
            ...metadata
          }
        )
      }).then(
        (res) => {

          console.log(res);

          if (typeof res !== undefined) {
            if (typeof res.status !== undefined) {
              if (res.status === 200) {

                handleSuccess();
                return;

              }
            }
          }
          handleError();

          /**
           * ¡ Done
           */
        }
      ).catch(
        (err) => {

          console.error(err);
          handleError();

        }
      );
    }
  }

  const countdown = (n) => {
    setTimeout(() => {
      if (n === 0)  {
        setCounter('');
        return;
      }
      setCounter(n);
      return countdown(n - 1);
    }, 1000);
  }

  return (
    <>
      <div className={`two text-center ${!success && ('invisible')}`} style={{opacity: success}}>
        <h3 className="text-success mb-3">{jt`Success`}</h3>
        <p>{jt`Your message has been sent`}.</p>
        <p>{jt`We will be in touch very shortly`}.</p>
        <div style={{minHeight: '100px'}}><h1 className="text-success">{counter}</h1></div>
      </div>

      <div className={`three text-center ${!error && ('invisible')}`} style={{opacity: error}}>
        <h3 className="text-danger mb-3">{jt`Schucks...`}</h3>
        <p>{jt`There's no active connection right now`}.</p>
        <p>{jt`Please call us on`} <span className="lead text-danger">+34 644 80 37 77</span>.</p>
        <div style={{minHeight: '100px'}}><h1 className="text-danger">{counter}</h1></div>
      </div>

      <div className="one">
        <Form>
          <FormField
            name="firstName"
            label={jt`First Name`}
            placeholder={jt`Arya`}
            text={<FormText>{jt`Letters, hyphens and spaces`}.</FormText>}
            data={state.firstName}
            onChange={(field, updatedState) => handleChange(field, updatedState)}
            validate={() => ValidateName('firstName', state.firstName, handleChange)}
          />
          <FormField
            name="lastName"
            label={jt`Last Name`}
            placeholder={jt`Stark`}
            text={<FormText>{jt`Letters, hyphens and spaces`}.</FormText>}
            data={state.lastName}
            onChange={(field, updatedState) => handleChange(field, updatedState)}
            validate={() => ValidateName('lastName', state.lastName, handleChange)}
          />
          <FormField
            name="email"
            label={jt`Email`}
            placeholder={jt`email@address.co`}
            text={<FormText>{jt`Please include an "@" and a ".xx"`}.</FormText>}
            data={state.email}
            onChange={(field, updatedState) => handleChange(field, updatedState)}
            validate={() => ValidateEmail('email', state.email, handleChange)}
          />
          <FormField
            name="tel"
            label={jt`Tel.`}
            placeholder={jt`+34 654 321 098`}
            text={
              <>
                <FormText>{jt`Please use the format +123 (0)456789012`}.</FormText>
                <FormText>{jt`Dashes, dots, spaces and parentheses can be used`}.</FormText>
              </>
            }
            data={state.tel}
            onChange={(field, updatedState) => handleChange(field, updatedState)}
            validate={() => ValidateTel('tel', state.tel, handleChange)}
          />
          <div className="row align-items-center pt-2">
            <div className="col-auto">
              {!loading && (
                <button
                  type="button"
                  className={`btn btn-dark btn-lg${valid ? ' flashing' : ''}`}
                  onClick={e => handleSubmit(e)}>
                  {valid ? jt`Click here...` : jt`Send`}
                </button>
              )}
              {loading && (
                  <Loading/>
              )}
            </div>
            <div className="col"></div>
          </div>

        </Form>
      </div>
    </>
  );
}

export default ContactForm;
